<template>
  <div class="row border-bottom">
    <div
      class="col-10 text-start menu-section"
      @click="toggleCurrentEdit('form')"
    >
      <h5>{{ $t("Menu.list.stones.group.formSetting.form") }}</h5>
      <p v-if="currentEdit != 'form'">
        {{ currentForm }}
        <span
          v-if="
            possibleItems.list.stoneAngle &&
            possibleItems.list.stoneAngle[0].angle != 0
          "
        >
          {{
            $tc(
              "Menu.list.stones.group.formSetting.angle.desc",
              possibleItems.list.stoneAngle[0].angle
            )
          }}
        </span>
      </p>
    </div>
    <div class="col-2 text-end">
      <img
        :src="appUrl + '/img/icons/edit.svg'"
        class="icon open"
        @click="toggleCurrentEdit('form')"
        v-if="currentEdit != 'form'"
      />
      <img
        :src="appUrl + '/img/icons/close.svg'"
        class="icon"
        @click="toggleCurrentEdit('form')"
        v-else
      />
    </div>
    <template v-if="currentEdit == 'form'">
      <div
        class="col-12 text-center"
        v-if="
          possibleItems.list.stoneAngle &&
          possibleItems.list.stoneAngle[0].isFormAllowed &&
          !possibleItems.list.tower
        "
      >
        <fieldset class="form-group">
          <div class="input-group">
            <div class="input-group-text">
              {{ $t("Menu.list.stones.group.formSetting.angle.title") }}
            </div>
            <input
              type="number"
              max="180"
              min="0"
              step="1"
              v-model="possibleItems.list.stoneAngle[0].angle"
              class="form-control"
              @change="
                changeItemByVarValue(
                  'stone-angle_' +
                    possibleItems.groupId +
                    '_' +
                    possibleItems.stoneId +
                    '_' +
                    $event.target.value
                )
              "
            />
            <div class="input-group-text">
              {{ $t("Menu.list.stones.group.formSetting.angle.rotate") }}
            </div>
          </div>
        </fieldset>
      </div>
      <div class="col-12 text-center">
        <ul class="default-option-list">
          <template v-for="(item, index) in possibleItems.list.forms">
            <li v-if="item.match" v-bind:key="index" class="pointer match">
              <img
                @error="$parent.$parent['setIconNotAvailable']($refs[item.id])"
                :ref="item.id"
                :src="
                  appUrl +
                  '/img/assets/stones/forms/' +
                  item.form.toLowerCase() +
                  '_g.jpg'
                "
                class="thumb"
                :srcset="
                  appUrl +
                  '/img/assets/stones/forms/' +
                  item.form.toLowerCase() +
                  '_g@2x.jpg'
                "
              />
              <p>{{ item.text }}</p>
            </li>
          </template>
          <template v-for="(item, index) in formsList">
            <li
              v-if="!item.match"
              v-bind:key="'form-' + index"
              @click="
                changeItemByVarValue(
                  'type_' +
                    possibleItems.groupId +
                    '_' +
                    possibleItems.stoneId +
                    '_' +
                    item.id
                )
              "
              class="pointer"
            >
              <img
                @error="$parent.$parent['setIconNotAvailable']($refs[item.id])"
                :ref="item.id"
                :src="
                  appUrl +
                  '/img/assets/stones/forms/' +
                  item.form.toLowerCase() +
                  '_g.jpg'
                "
                class="thumb"
                :srcset="
                  appUrl +
                  '/img/assets/stones/forms/' +
                  item.form.toLowerCase() +
                  '_g@2x.jpg'
                "
              />
              <p>{{ item.text }}</p>
            </li>
          </template>
          <li
            v-if="
              form.show != 'form' &&
              possibleItems.list.forms.length > form.maxItems
            "
            @click="form.show = 'form'"
          >
            <img :src="appUrl + '/img/icons/next.svg'" class="ring" />
            {{ $t("Menu.list.stones.group.formSetting.add") }} &gt;
          </li>
        </ul>
      </div>
    </template>
  </div>
</template>

<script>
import Config from "@/vuex/Config";

export default {
  name: "Form",
  props: ["possibleItems", "currentEdit", "itemData", "stoneId", "groupId"],
  data() {
    return {
      appUrl: Config.getters.getAppUrl,
      imageHost: process.env.VUE_APP_IMAGE_HOST,
      form: {
        show: "form",
        maxItems: 99,
      },
    };
  },
  computed: {
    formsList: function () {
      let list = [];

      if (typeof this.possibleItems.list.forms == "object") {
        for (let key in this.possibleItems.list.forms) {
          if (
            Object.prototype.hasOwnProperty.call(
              this.possibleItems.list.forms,
              key
            )
          ) {
            if (
              (list.length < this.form.maxItems || this.form.show === "form") &&
              this.possibleItems.list.forms[key].match == false
            ) {
              list.push(this.possibleItems.list.forms[key]);
            }
          }
        }
      }

      return list;
    },
    currentForm: function () {
      if (typeof this.possibleItems.list.forms == "object") {
        for (let key in this.possibleItems.list.forms) {
          if (
            Object.prototype.hasOwnProperty.call(
              this.possibleItems.list.forms,
              key
            )
          ) {
            if (this.possibleItems.list.forms[key].match == true) {
              return this.possibleItems.list.forms[key].text;
            }
          }
        }
      }

      return "";
    },
  },
  methods: {
    toggleCurrentEdit: function (id) {
      this.$parent.toggleCurrentEdit(id);
    },
    changeItemByVarValue: function (varValue) {
      this.$parent.changeItemByVarValue(varValue);
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
#app {
  .menu-section {
    cursor: pointer;
  }

  label {
    font-weight: normal;
    line-height: 2.2em;
  }

  .text-bold {
    font-weight: bold;
  }

  img.ring {
    display: block;
    width: 5em;
    height: 5em;
    border-radius: 5em;
    border: solid 0.1rem $brandDarkGrey;
    margin: auto;
    margin-bottom: 0.5em;
  }

  .input-group input,
  .input-group select {
    height: 2.5em;
  }
}
</style>
